import React from 'react';

/**
 * Component to display a "down arrow" svg icon
 * @param {*} props - Generic parameter to pass along any desired props to the component
 */

const SvgLeftArrowIcon = (props) => (
  <svg
    viewBox="0 0 22 22"
    width="1em"
    height="1em"
    {...props}
    id="LeftArrowIcon">
    <path d="M7 4v4.8h15v4.4H7V18l-7-7 7-7z" fill="currentColor" />
  </svg>
);

export default SvgLeftArrowIcon;
